export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enregistrer"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Si vous voyez ceci, le formulaire n'a pas été reçu (mais vous ne devriez pas voir cela)"])}
}